'use strict';

$(document).ready(function() {
    $('ul.tabs li a').click(function(e) {
        e.preventDefault();
        $('ul.tabs li.active').removeClass('active');
        $('.tabs-wrapper .tab.active').removeClass('active');
        var newActiveTab = $(this).closest('li').attr('id');
        $('ul.tabs li#' + newActiveTab).addClass('active');
        $('.tabs-wrapper .tab#' + newActiveTab).addClass('active');
    });
});